<div class="survey-container">
  @if (errorMessage) {
    <p class="survey-form__error" role="alert">{{ errorMessage }}</p>
  }

  <div class="survey-preview-wrapper" role="region" aria-label="Survey preview mode">
    <div class="survey-preview-wrapper__banner" role="status" aria-live="polite">
      <strong>Preview</strong> — Click any question, answer, or score to edit. Drag the handle to reorder questions. Changes save automatically.
    </div>
    <div class="survey-preview-wrapper__content">
      @if (editReady && version) {
        <div class="survey-intake survey-preview-editable">
          <header class="survey-intake__header" aria-label="Survey introduction">
            <h1 class="survey-intake__title">{{ version.surveyTypeName ?? 'Survey' }}</h1>
            <p class="survey-intake__intro">Please answer the questions below.</p>
          </header>

          <div class="survey-preview-questions" cdkDropList (cdkDropListDropped)="onQuestionDrop($event)">
            @for (q of editQuestions; track q.id) {
              <section
                class="survey-intake__question survey-preview-question"
                cdkDrag
                [attr.aria-labelledby]="'preview-q-label-' + q.id"
                [attr.data-question-id]="q.id"
              >
                <span class="survey-preview-drag-handle" cdkDragHandle aria-label="Drag to reorder question">⋮⋮</span>
                <div class="survey-preview-question-inner">
                  @if (editingQuestionId === q.id) {
                    <input
                      class="survey-form__input survey-preview-inline-input"
                      type="text"
                      [value]="q.questionText"
                      (blur)="saveQuestionText(q, $event)"
                      (keydown.enter)="$event.target.blur()"
                    />
                  } @else {
                    <h3
                      [id]="'preview-q-label-' + q.id"
                      class="survey-intake__question-title survey-preview-clickable"
                      (click)="startEditQuestion(q)"
                    >
                      {{ q.questionText || 'Click to add question' }}
                    </h3>
                  }

                  @if (q.questionType === 'Radio') {
                    <fieldset class="survey-form__fieldset" [attr.aria-describedby]="'preview-q-desc-' + q.id">
                      <legend class="sr-only">{{ q.questionText }}</legend>
                      <ul class="survey-form__radio-list" role="radiogroup">
                        @for (a of getEditAnswers(q.id); track a.id) {
                          <li>
                            <label class="survey-form__radio-label survey-preview-radio-label">
                              <input
                                type="radio"
                                [name]="'preview-q-' + q.id"
                                [value]="a.id"
                                class="survey-form__radio"
                                disabled
                                tabindex="-1"
                                aria-hidden="true"
                              />
                              @if (editingAnswerId === a.id) {
                                <input
                                  class="survey-form__input survey-preview-inline-input"
                                  type="text"
                                  [value]="a.answerText"
                                  (click)="$event.stopPropagation()"
                                  (blur)="saveAnswerText(a, $event)"
                                  (keydown.enter)="$event.target.blur()"
                                />
                              } @else {
                                <span
                                  class="survey-preview-answer-text"
                                  (click)="startEditAnswerText(a); $event.preventDefault()"
                                >{{ a.answerText || 'Click to add answer' }}</span>
                              }
                              @if (editingScoreId === a.id) {
                                <input
                                  class="survey-form__input survey-preview-score-input"
                                  type="number"
                                  [value]="a.score"
                                  (click)="$event.stopPropagation()"
                                  (blur)="saveAnswerScore(a, $event)"
                                  (keydown.enter)="$event.target.blur()"
                                  min="0"
                                  step="1"
                                />
                              } @else {
                                <span
                                  class="survey-preview-score"
                                  (click)="startEditScore(a); $event.preventDefault()"
                                  title="Click to edit score"
                                >({{ a.score ?? 0 }} pts)</span>
                              }
                            </label>
                          </li>
                        }
                      </ul>
                      <p [id]="'preview-q-desc-' + q.id" class="sr-only">Select one option.</p>
                    </fieldset>
                  }

                  @if (q.questionType === 'FreeFormText') {
                    <div class="survey-form__text-block">
                      <textarea
                        class="survey-form__textarea survey-form__input"
                        [id]="'preview-q-free-' + q.id"
                        rows="3"
                        [maxlength]="q.maxCharacterCount ?? 500"
                        placeholder="Your answer..."
                        disabled
                        tabindex="-1"
                      ></textarea>
                      <p class="survey-form__char-count">{{ q.maxCharacterCount ?? 500 }} characters max</p>
                    </div>
                  }
                </div>
              </section>
            }
          </div>
        </div>
      } @else {
        <p role="status">Loading preview...</p>
      }
    </div>
  </div>

  <div class="survey-preview-actions">
    <a class="btn survey-form__cancel" [routerLink]="['/admin/survey-types', typeId, 'edit']" [queryParams]="versionId ? { versionId } : {}">Back to edit</a>
    @if (editReady && isDraft) {
      <button type="button" class="btn btn-primary survey-preview-publish-btn" (click)="publishVersion()" [disabled]="publishInProgress" [attr.aria-busy]="publishInProgress">
        {{ publishInProgress ? 'Publishing...' : 'Publish survey' }}
      </button>
    }
  </div>
</div>
